module.exports = __webpack_public_path__ + "roboto-latin-400-normal.b009a76ad6afe4ebd301e36f847a29be.hashedasset.woff2";